// extracted by mini-css-extract-plugin
module.exports = {"answer":"accordion_answer__tWxlN"};